<ng-container *ngIf="temporaryCustomer">
  <div class="dialog-header">
    <div class="header-title"><span>{{header}}</span></div>

    <div class="qb-sync-block" [ngClass]="{'has-sync': qbConnected}"
         pTooltip="{{qbConnected ? 'QB Sync' : 'No sync with QB'}}" tooltipPosition="bottom">
      QB
    </div>

    <div class="buttons-block">
      <button class="header-button" mat-button (click)="connectToQb()" *ngIf="qbConnected">Change QB</button>
      <button class="header-button" mat-button (click)="openQB()" *ngIf="qbConnected">Open QB</button>
      <button class="header-button" mat-button (click)="connectToQb()" *ngIf="!qbConnected">Connect QB</button>
    </div>

    <div style="flex: 1">

    </div>

    <div class="buttons-block">
      <button class="active-button" [class.active]="temporaryCustomer.active" mat-button
              (click)="toggleActive()">Active
      </button>
    </div>

    <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="middle-content">
    <div class="contacts-loading-screen" *ngIf="customerLoading || projectsLoading">
      <lib-progress-spinner></lib-progress-spinner>
    </div>

    <form #editCustomerForm="ngForm" *ngIf="!customerLoading && !projectsLoading">

      <div class="customer-row row-block">
        <div class="customer-row-title row-title">Customer</div>
        <div class="customer-block div-block">
          <div class="customer-info row-block">
            <div class="customer-label">Name:</div>
            <div class="customer-span">
              <input class="text-input" type="text" [(ngModel)]="temporaryCustomer.name" name="name">
            </div>
          </div>
          <div class="customer-info row-block">
            <div class="customer-label">WholeSaler:</div>
            <div class="customer-span customer-checkbox">
              <p-checkbox [(ngModel)]="temporaryCustomer.isWholesaler" [binary]="true"
                          [ngModelOptions]="{standalone: true}" (onChange)="saveCustomer()">
              </p-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="delete-row row-block">
        <div class="project-row-title row-title">Attachments</div>
        <div class="files-block div-block">
          <div class="email-input-text" *ngIf="filesLoading">
            <lib-progress-spinner></lib-progress-spinner>
          </div>
          <div class="email-input-text" *ngIf="!filesLoading">
            <div class="file-names">
              <div class="file" *ngFor="let customerFile of customerFiles; let i = index" [ngClass]="{'picture-file-block': customerFile.ext ==='jpg' || customerFile.ext ==='jpeg' ||
		customerFile.ext==='png' || customerFile.ext==='gif' || customerFile.ext==='webp'}">
                <div class="file-icon"
                     *ngIf="customerFile.ext !== 'jpg' && customerFile.ext !== 'jpeg' && customerFile.ext !== 'png' && customerFile.ext !== 'gif' && customerFile.ext !== 'webp'">
                  <mat-icon class="material-icons-outlined md-18">{{getIcon(customerFile.ext)}}</mat-icon>
                </div>
                <div class="file-thumbnail"
                     *ngIf="customerFile.ext === 'jpg' || customerFile.ext === 'jpeg' || customerFile.ext === 'png' || customerFile.ext === 'gif' || customerFile.ext === 'webp'"
                     (click)="openFile(customerFile)">
                  <img [src]="getTinyIcon(customerFile.id)">
                </div>
                <div class="file-block"
                     [ngClass]="{'tablet-files': !isDesktop, 'mobile-files': isMobile}">
                  <div class="file-name">
                    <span (click)="openFile(customerFile)">{{customerFile?.name}}</span>
                  </div>
                  <div class="fila-infa">
                    <div class="file-info">
                      {{customerFile.user?.username}},
                    </div>

                    <div class="file-info">
                      {{customerFile.uploadTime | date: 'MMM dd, yyyy'}}
                    </div>
                  </div>

                </div>

                <span class="delete-icon" (click)="deleteFile(customerFile, i)">
                  <mat-icon>clear</mat-icon>
                </span>
              </div>
            </div>
            <span *ngIf="customerFiles?.length === 0">No Files</span>
          </div>

          <mat-progress-bar *ngIf="progressBar > 0" mode="determinate" value="{{progressBar}}">
          </mat-progress-bar>

          <p-fileUpload #fileUpload mode="advanced" name="files" #filesForm (onProgress)="onProgress($event)"
                        [customUpload]="true"
                        (uploadHandler)="uploadFiles($event.files, filesForm)" [auto]="true" [multiple]="true"
                        chooseLabel="Upload" *ngIf="!filesLoading">
            <ng-template pTemplate="content">
              <div class="attachments-block" (click)="chooseFile()">
                <i class="pi pi-download" style="font-size: 130%; margin-bottom: 0.4em;"></i>
                <div>
                  <span class="add-attachment">Choose a file</span>
                  <span class="drop-here"> or drag it here.</span>
                </div>
              </div>
            </ng-template>
          </p-fileUpload>
        </div>
      </div>
      <div class="customer-row row-block">
        <div class="customer-row-title row-title">Billing Info</div>
        <div class="customer-block div-block">
          <div class="customer-info row-block">
            <div class="customer-label">Billing Name:</div>
            <div class="customer-span">
              <input class="text-input" type="text"
                     [(ngModel)]="temporaryCustomer?.billingInfoContact.name" name="billingContactName">
            </div>
          </div>
          <div class="customer-info row-block">
            <div class="customer-label">Street:</div>
            <div class="customer-span">
              <input class="text-input" type="text"
                     [(ngModel)]="temporaryCustomer?.billingInfoContact.street" name="billingContactStreet">
            </div>
          </div>
          <div class="customer-info row-block">
            <div class="customer-label">City:</div>
            <div class="customer-span">
              <input class="text-input" type="text"
                     [(ngModel)]="temporaryCustomer?.billingInfoContact.city" name="billingContactCity">
            </div>
          </div>
          <div class="customer-info row-block">
            <div class="customer-label">State:</div>
            <div class="customer-span">
              <input class="text-input" type="text"
                     [(ngModel)]="temporaryCustomer?.billingInfoContact.state" name="billingContactState">
            </div>
          </div>
          <div class="customer-info row-block">
            <div class="customer-label">Zip:</div>
            <div class="customer-span">
              <input class="text-input" type="text"
                     [(ngModel)]="temporaryCustomer?.billingInfoContact.zipCode" name="billingContactZip">
            </div>
          </div>
          <div class="customer-info row-block">
            <div class="customer-label">Phone:</div>
            <div class="customer-span">
              <!-- <input class="text-input" type="number"
                [(ngModel)]="temporaryCustomer?.billingInfoContact.phone1" name="phone1"> -->

              <p-inputMask mask="(999) 999-9999" class="text-input" (ngModelChange)="telephoneChanged()"
                           [autoClear]="false" [(ngModel)]="temporaryCustomer?.billingInfoContact.phone1"
                           [ngModelOptions]="{standalone: true}">
              </p-inputMask>
            </div>
          </div>
          <div class="customer-info row-block">
            <div class="customer-label">E-Mail:</div>
            <div class="customer-span">
              <input class="text-input" type="email"
                     [(ngModel)]="temporaryCustomer?.billingInfoContact.email" name="email">
            </div>
          </div>
          <div class="textarea-line">
            <textarea matInput placeholder="Notes" type="text" [(ngModel)]="temporaryCustomer.notes"
                      name="notes"></textarea>
          </div>
        </div>
      </div>
      <div class="customer-row row-block">
        <div class="customer-row-title row-title">Contacts</div>
        <div class="contacts-block div-block">
          <div class="contacts" *ngIf="temporaryCustomer.contacts.length > 0">
            <div class="customer-block div-block">
              <p-accordion [activeIndex]="openThisContact">
                <p-accordionTab header="" *ngFor="let contact of temporaryCustomer.contacts">

                  <p-header>
										<span class="material-icons letter-icon"
                          (click)="chooseContact($event, contact)"
                          *ngIf="projectId && !letterLoadingIdMap.has(contact.id)"
                          [ngClass]="{'choosen-contact': choosenContactsMap.has(contact.id)}">
											mark_email_read
										</span>

                    <mat-spinner *ngIf="letterLoadingIdMap.has(contact.id)"></mat-spinner>


                    {{contact.name}} {{contact.phone1}}
                  </p-header>

                  <div class="contact-row">
                    <app-contact-info [contact]="contact"></app-contact-info>
                  </div>

                  <mat-icon class="delete-icon" (click)="deleteContact(contact)">
                    delete_outline
                  </mat-icon>

                </p-accordionTab>
              </p-accordion>
            </div>
          </div>

          <div class="no-contacts-block" *ngIf="temporaryCustomer.contacts.length <= 0">
            <div class="contact-title">No any Contacts</div>
          </div>
          <div class="new-contact-block">
            <button mat-button class="add-contact-button" (click)="createNewContactBlock()">
              <mat-icon>add</mat-icon>
              <div class="button-title">Add new contact</div>
            </button>
          </div>

        </div>
      </div>
      <div class="project-row row-block">
        <div class="project-row-title row-title">Projects</div>
        <div class="projects-block" *ngIf="projects?.length > 0">
          <div class="project-block" *ngFor="let project of projects">
            <div class="title-block">
              <div class="project-title" (click)="openProject(project.id)">
                <div class="project-span">{{project.name}}</div>

                <div class="project-status">
                  <span class="status-span">{{project.status}}</span>
                </div>
              </div>
            </div>

            <div class="label-spanchik" style.background-color="#{{project.paymentStatus?.color}}">
              {{project.paymentStatus?.title}}</div>
          </div>
        </div>

        <div class="projects-block" *ngIf="projects?.length <= 0">
          <div class="project-title">No Projects</div>
        </div>
      </div>
      <div class="delete-row row-block">
        <div class="project-row-title row-title">Actions</div>
        <div class="delete-block div-block">
          <button mat-button class="delete-contact-button" (click)="deleteCustomer()">
            <mat-icon>delete</mat-icon>
            <div class="button-title">Delete Customer</div>
          </button>
        </div>
      </div>

      <p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="customer-panel">
      </p-confirmDialog>
    </form>
  </div>
</ng-container>
